import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { ArrowRight } from "lucide-react";

export default function MentorProjectsPage() {
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/mentor/projects").then((r) => setProjects(r.data)).finally(() => setLoading(false));
  }, []);

  return (
    <div data-testid="mentor-projects-page">
      <div className="kb-mono text-[10px] uppercase tracking-[0.2em] text-kb-ink-muted">ASSIGNED PROJECTS</div>
      <h1 className="font-serif text-3xl lg:text-4xl text-kb-ink mt-1">Projects under your <em className="italic text-kb-primary">mentorship</em></h1>

      {loading ? <div className="mt-8 kb-mono text-xs text-kb-ink-muted">Loading…</div> :
        projects.length === 0 ? (
          <div className="mt-10 text-center py-16 border border-dashed border-slate-300 rounded-sm bg-white text-sm text-kb-ink-muted">No projects assigned yet.</div>
        ) : (
          <div className="mt-8 grid gap-px bg-slate-200 border border-slate-200 rounded-sm overflow-hidden">
            {projects.map((p) => (
              <Link key={p.id} to={`/mentor/ideas/${p.id}`}
                className="bg-white p-6 hover:bg-slate-50 transition-colors flex flex-col lg:flex-row lg:items-center gap-4"
                data-testid={`mentor-project-row-${p.id}`}>
                <div className="flex-1 min-w-0">
                  <div className="kb-mono text-[10px] uppercase tracking-wider text-kb-ink-muted">{p.id} · {p.domain} · client: {p.user_name}</div>
                  <div className="font-serif text-lg text-kb-ink mt-1">{p.title}</div>
                  <div className="text-sm text-kb-ink-muted mt-1 line-clamp-2">{p.abstract}</div>
                </div>
                <div className="flex items-center gap-4">
                  <span className="kb-mono text-[10px] uppercase text-kb-primary bg-kb-primary/5 border border-kb-primary/15 px-2 py-1 rounded-sm">{p.status}</span>
                  <ArrowRight className="w-4 h-4 text-kb-ink-light" />
                </div>
              </Link>
            ))}
          </div>
        )}
    </div>
  );
}
